class LocationsBlock {
  /**
   * Add custom JavaScript to the block HTML.
   *
   * @param   Element  block       The block element
   * @param   object   attributes  The block attributes (only available when editing)
   * @return  void
   */
  constructor(block, attributes = null) {
    this.block = block;
    this.regionSelect = block.querySelector('.locations__select--region');
    this.countrySelect = block.querySelector('.locations__select--country');

    if (this.regionSelect) {
      this.regionSelect.addEventListener('change', () => {
        window.location.href = this.regionSelect.value;
      });
    }

    if (this.countrySelect) {
      this.countrySelect.addEventListener('change', () => {
        window.location.href = this.countrySelect.value;
      });
    }
  }
}

// Initialize each block on page load (front end)
document.querySelectorAll('.locations').forEach((block) => {
  new LocationsBlock(block);
});

// Initialize the dynamic block preview (editor)
if (window.acf) {
  window.acf.addAction('render_block_preview/type=locations', ($block, attributes) => {
    new LocationsBlock($block.find('.locations').get(0), attributes);
  });
}